import { render, staticRenderFns } from "./FAQLine.vue?vue&type=template&id=bee81f06&scoped=true&"
import script from "./FAQLine.vue?vue&type=script&setup=true&lang=js&"
export * from "./FAQLine.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FAQLine.vue?vue&type=style&index=0&id=bee81f06&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee81f06",
  null
  
)

export default component.exports